import { cn } from "@theprelude/core";
import { Button, ChevronIcon, IconButton } from "@theprelude/ds";
import { CellInfo } from "./columns";

const RotatingChevronIcon = ({ active }: { active: boolean }) => (
  <ChevronIcon
    className={cn(
      "rotate-180 transform fill-secondary-foreground transition-transform duration-300",
      active && "rotate-360",
    )}
  />
);

export const ExpandableContentButton = <TData,>({
  row,
  label,
}: {
  row: CellInfo<TData>["row"];
  label?: string;
}) => {
  if (!row.getCanExpand()) {
    return label;
  }

  const icon = <RotatingChevronIcon active={row.getIsExpanded()} />;
  const onClick = row.getToggleExpandedHandler();

  if (!label) {
    return <IconButton icon={icon} onClick={onClick} />;
  }

  return (
    <Button
      icon={icon}
      onClick={onClick}
      intent="text-link"
      className="gap-1 whitespace-nowrap px-0 no-underline"
    >
      {label}
    </Button>
  );
};
